/* tslint:disable */
/* eslint-disable */
export enum TargetType {
  Absolute = 'ABSOLUTE',
  AbsoluteGrowth = 'ABSOLUTE_GROWTH',
  ParameterUpdate = 'PARAMETER_UPDATE',
  RelativeGrowth = 'RELATIVE_GROWTH',
  ResourceShift = 'RESOURCE_SHIFT',
  Standard = 'STANDARD',
}
